export default __webpack_public_path__ + "static/media/profile4.5550c22b.png";